(function($, Global) {
    function EditionModel() {
        // Déclaration class objet
    }

    EditionModel.prototype.getUne = function(data, callback) {
        $.ajaxPost('/ajax/archives/edition', data)
            .done(function(result) {
                Global.ajaxCallback({
                    results: result,
                    success: callback
                });
            });
    }

    Global.EditionModel = EditionModel;

}(jQuery, window));